import countries from 'i18n-iso-countries'
import de from 'i18n-iso-countries/langs/de.json'
import en from 'i18n-iso-countries/langs/en.json'
import i18n from 'i18next'

countries.registerLocale(en)
countries.registerLocale(de)

const countryToFlag = (code: string) => {
  return typeof String.fromCodePoint !== 'undefined'
    ? code
        .toUpperCase()
        .replace(/./g, (char) =>
          String.fromCodePoint(char.charCodeAt(0) + 127397)
        )
    : code
}

export interface Country {
  id: string
  label: string
}

const getCountries = (): Country[] =>
  Object.entries(countries.getNames(i18n.language || 'en')).map(
    ([id, label]) => ({ id, label })
  )

const getCountryNameByCode = (code: string): string => {
  return getCountries().find((country) => country.id === code)?.label || ''
}

export { countryToFlag, getCountries, getCountryNameByCode }
